// extracted by mini-css-extract-plugin
export default {"card":"card-module--card--2MTyh","clickeableCard":"card-module--clickeable-card--188Rr"};